export const SIDEBAR_NAMES = {
  main: "Main",
  traffic: "Traffic",
  finance: "Finance",
  includes: "Includes",
  analytics: "Analytics",
  testing: "Testing",
};

export type SidebarGroup = keyof typeof SIDEBAR_NAMES;

export const SIDEBAR_GROUPS = [
  "main",
  "traffic",
  "finance",
  "includes",
  "analytics",
  "testing",
] satisfies SidebarGroup[];
